import React, { RefObject } from 'react';
import {
  ActivityIndicator,
  Platform,
  Pressable,
  StyleProp,
  TextInput,
  ViewStyle,
} from 'react-native';

import {
  ADMIN_TABLE_SEARCH_HIT_SLOP,
  ADMIN_TABLE_SEARCH_MAX_LENGTH,
} from './adminTableLayoutConstants';
import { adminTableMemberGridStyles } from './adminTableMemberGridStyles';
import { colors } from '../../theme/colors';
import { Search } from '../icons';

export interface AdminTableHeaderSearchProps {
  inputRef: RefObject<TextInput | null>;
  value: string;
  onChangeText: (text: string) => void;
  onFocus: () => void;
  onBlur: () => void;
  focused: boolean;
  placeholder: string;
  accessibilityLabel: string;
  searchBoxTestID?: string;
  searchInputTestID?: string;
  isSearching?: boolean;
  editable?: boolean;
  boxStyle?: StyleProp<ViewStyle>;
  /** iOS only. The screen must also render a `KeyboardDismissToolbar` with this id. */
  inputAccessoryViewID?: string;
}

export const AdminTableHeaderSearch: React.FC<AdminTableHeaderSearchProps> = ({
  inputRef,
  value,
  onChangeText,
  onFocus,
  onBlur,
  focused,
  placeholder,
  accessibilityLabel,
  searchBoxTestID,
  searchInputTestID,
  isSearching = false,
  editable = true,
  boxStyle,
  inputAccessoryViewID,
}) => (
  <Pressable
    style={[
      adminTableMemberGridStyles.headerSearch,
      focused && adminTableMemberGridStyles.headerSearchFocused,
      !editable && adminTableMemberGridStyles.headerSearchDisabled,
      boxStyle,
    ]}
    onPress={() => inputRef.current?.focus()}
    hitSlop={ADMIN_TABLE_SEARCH_HIT_SLOP}
    accessible={false}
    testID={searchBoxTestID}
  >
    <Search size={16} color={colors.textMuted} />
    <TextInput
      ref={inputRef}
      testID={searchInputTestID}
      value={value}
      onChangeText={onChangeText}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      placeholderTextColor={colors.textMuted}
      numberOfLines={1}
      maxLength={ADMIN_TABLE_SEARCH_MAX_LENGTH}
      style={[
        adminTableMemberGridStyles.headerSearchInput,
        Platform.OS === 'android' &&
          adminTableMemberGridStyles.headerSearchInputAndroid,
      ]}
      editable={editable}
      autoCapitalize="none"
      autoCorrect={false}
      accessibilityLabel={accessibilityLabel}
      returnKeyType="search"
      inputAccessoryViewID={
        Platform.OS === 'ios' && editable ? inputAccessoryViewID : undefined
      }
    />
    {isSearching ? (
      <ActivityIndicator
        color={colors.primary}
        accessibilityLabel="Searching users"
      />
    ) : null}
  </Pressable>
);
